import { designSystemStyles } from "@shared/styles/designSystemStyles";
import {
    AndroidLogoIcon,
    AppleLogoIcon,
    BankIcon,
    BellIcon,
    BuildingsIcon,
    CalendarBlankIcon,
    CameraIcon,
    CaretRightIcon,
    ChartBarIcon,
    ChatCircleTextIcon,
    CheckSquareIcon,
    ClockIcon,
    CubeIcon,
    DeviceMobileIcon,
    DotsThreeVerticalIcon,
    DownloadSimpleIcon,
    EnvelopeSimpleIcon,
    EyeIcon,
    GearSixIcon,
    HouseIcon,
    InfoIcon,
    ListBulletsIcon,
    LockSimpleIcon,
    MagnifyingGlassIcon,
    MapPinIcon,
    MegaphoneIcon,
    MoonIcon,
    NoteBlankIcon,
    PaperPlaneTiltIcon,
    PencilSimpleLineIcon,
    QrCodeIcon,
    QuestionIcon,
    RobotIcon,
    RocketLaunchIcon,
    RowsIcon,
    SignOutIcon,
    SmileyIcon,
    SquaresFourIcon,
    StarIcon,
    TableIcon,
    TicketIcon,
    TrayIcon,
    TrashIcon,
    UserCircleIcon,
    UserPlusIcon,
    UsersThreeIcon,
    WallIcon,
    WarningIcon,
    XIcon,
    type Icon,
    type IconWeight,
    UserFocusIcon,
    UserCheckIcon,
    ArrowsClockwiseIcon,
} from "@phosphor-icons/react";

export type SystemIconType =
    | 'alert'
    | 'android'
    | 'apple'
    | 'bell'
    | 'bank'
    | 'building'
    | 'calendar'
    | 'camera'
    | 'check'
    | 'chart'
    | 'chart2'
    | 'chevron'
    | 'clock'
    | 'close'
    | 'dark_mode'
    | 'dashboard'
    | 'delete'
    | 'device-mobile'
    | 'download'
    | 'edit'
    | 'email'
    | 'eye'
    | 'face'
    | 'finder'
    | 'help'
    | 'home'
    | 'inbox'
    | 'info'
    | 'listado'
    | 'lock'
    | 'logout'
    | 'map'
    | 'megaphone'
    | 'more'
    | 'notes'
    | 'people'
    | 'people2'
    | 'profile'
    | 'qr'
    | 'rocket'
    | 'roster'
    | 'search'
    | 'send'
    | 'settings'
    | 'star'
    | 'ticket'
    | 'wall'
    | 'warning-triangle'
    | 'box'
    | "user-focus"
    | "user-verified"
    | "reset"

// Icons come from Phosphor (https://phosphoricons.com). To add a new icon,
// extend SystemIconType and register the Phosphor component here.
const PHOSPHOR_ICONS: Record<SystemIconType, Icon> = {
    'alert': ChatCircleTextIcon,
    'android': AndroidLogoIcon,
    'apple': AppleLogoIcon,
    'bell': BellIcon,
    'bank': BankIcon,
    'building': BuildingsIcon,
    'calendar': CalendarBlankIcon,
    'camera': CameraIcon,
    'check': CheckSquareIcon,
    'chart': TableIcon,
    'chart2': ChartBarIcon,
    'chevron': CaretRightIcon,
    'clock': ClockIcon,
    'close': XIcon,
    'dark_mode': MoonIcon,
    'dashboard': SquaresFourIcon,
    'delete': TrashIcon,
    'device-mobile': DeviceMobileIcon,
    'download': DownloadSimpleIcon,
    'edit': PencilSimpleLineIcon,
    'email': EnvelopeSimpleIcon,
    'eye': EyeIcon,
    'face': SmileyIcon,
    'finder': RobotIcon,
    'help': QuestionIcon,
    'home': HouseIcon,
    'inbox': TrayIcon,
    'info': InfoIcon,
    'listado': ListBulletsIcon,
    'lock': LockSimpleIcon,
    'logout': SignOutIcon,
    'map': MapPinIcon,
    'megaphone': MegaphoneIcon,
    'more': DotsThreeVerticalIcon,
    'notes': NoteBlankIcon,
    'people': UserPlusIcon,
    'people2': UsersThreeIcon,
    'profile': UserCircleIcon,
    'qr': QrCodeIcon,
    'rocket': RocketLaunchIcon,
    'roster': RowsIcon,
    'search': MagnifyingGlassIcon,
    'send': PaperPlaneTiltIcon,
    'reset': ArrowsClockwiseIcon,
    'settings': GearSixIcon,
    'star': StarIcon,
    'ticket': TicketIcon,
    'wall': WallIcon,
    'warning-triangle': WarningIcon,
    'box': CubeIcon,
    'user-focus': UserFocusIcon,
    'user-verified': UserCheckIcon,
};

interface SystemIconProps {
    color: string
    type: SystemIconType
    className?: string
    size?: "small" | "medium" | "large"
    weight?: IconWeight
}
export const SystemIcon: React.FC<SystemIconProps> = ({
    size = "medium",
    weight = "regular",
    ...props
}) => {

    let resolvedSize: string;
    switch (size) {
        case "small":
            resolvedSize = designSystemStyles.sizeIconSm
            break;
        case "medium":
            resolvedSize = designSystemStyles.sizeIconMd
            break;
        case "large":
            resolvedSize = designSystemStyles.sizeIconLg
            break;
        default:
            resolvedSize = designSystemStyles.sizeIconMd
    }

    const iconStyle = {
        width: resolvedSize,
        height: resolvedSize,
        color: props.color ?? designSystemStyles.colorText
    };
    const iconClassName = ['DSSystemIcon', props.className].filter(Boolean).join(' ');

    const IconComponent = PHOSPHOR_ICONS[props.type];
    return <IconComponent style={iconStyle} className={iconClassName} weight={weight} />;
}
